import kairosLogoSrc from "@/assets/kairos-logo.png";

export function KairosLogo({
  size = 44,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-xl bg-gradient-to-br from-primary/15 via-transparent to-success/15 ring-1 ring-primary/20 shadow-glow ${className}`}
      style={{ width: size, height: size }}
      aria-label="Kairos"
    >
      <img
        src={kairosLogoSrc}
        width={size}
        height={size}
        alt="Kairos"
        loading="lazy"
        className="object-contain"
        style={{ width: size * 0.85, height: size * 0.85 }}
      />
    </span>
  );
}
